/*
 * @Description  :
 * @Author       : tcsl-fast-tianyu
 * @Date         : 2025-10-11
 * @LastEditors  : tcsl-fast-tianyu
 * @LastEditTime : 2025-10-11
 */
'use strict'
import { execSync } from 'child_process'

/**
 * Git 命令执行结果接口
 */
export interface GitCommandResult {
  success: boolean
  output: string
  error?: string
}

/**
 * 执行 Git 命令的安全包装器
 */
export class GitService {
  static execCommand(command: string): GitCommandResult {
    try {
      const output = execSync(command, {
        stdio: 'pipe',
        encoding: 'utf8',
        timeout: 5000, // 5秒超时
      })
        .toString()
        .trim()

      return {
        success: true,
        output,
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      return {
        success: false,
        output: '',
        error: errorMessage,
      }
    }
  }

  /**
   * 获取所有 Git 信息
   */
  static getAllGitInfo(): Record<string, string> {
    const gitCommands = {
      commitHash: 'git rev-parse HEAD',
      commitShort: 'git rev-parse --short HEAD',
      branch: 'git rev-parse --abbrev-ref HEAD',
      tag: 'git describe --tags --exact-match 2>/dev/null || echo ""',
      commitCount: 'git rev-list --count HEAD',
      commitDate: 'git log -1 --format=%ci',
      commitMessage: 'git log -1 --format=%s',
      author: 'git log -1 --format=%an',
      email: 'git log -1 --format=%ae',
      dirty: 'git diff --quiet; echo $?',
    }

    return Object.entries(gitCommands).reduce(
      (acc, [key, command]) => {
        const result = this.execCommand(command)
        acc[key] = result.success ? result.output : ''
        return acc
      },
      {} as Record<string, string>
    )
  }
}
